<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('odds')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                   
                </div>
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
        />
        
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";

export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    props: ['league_id'],
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'games-table',
            rowData: {},
            lineOptions: [],
            marketOptions: [],
            subMarketOptions: [],
            options: {
                name: 'GamesTable',
                showHeader: true,
                //enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [
                    {
                        title: 'ID',
                        type: 'custom-html',
                        key: 'id',
                        modifier: (value, row) => {
                            return '<a href="/game/' + value + '" target="_blank">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('time'),
                        type: 'text',
                        key: 'event_start_time',

                    },
                    {
                        title: this.$t('sport'),
                        type: 'text',
                        key: 'sport',

                    },
                    /*{
                        title: this.$t('name'),
                        type: 'text',
                        key: 'name',

                    },*/
                    {
                        title: this.$t('team_1'),
                        type: 'custom-html',
                        key: 'team1',
                        modifier: (value, row) => {
                            return '<a href="/team/' + row.team_1_id + '" target="_blank" class="hidden-link">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('team_2'),
                        type: 'custom-html',
                        key: 'team2',
                        modifier: (value, row) => {
                            return '<a href="/team/' + row.team_2_id + '" target="_blank" class="hidden-link">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('league'),
                        type: 'custom-html',
                        key: 'league',
                        modifier: (value, row) => {
                            return '<a href="/league/' + row.league_id + '" target="_blank" class="hidden-link">' + value + '</a>';
                        }
                    },
                    {
                        title: this.$t('wdw'),
                        type: 'wdw',
                        key: 'wdw',

                    },
                    {
                        title: this.$t('asian_handicap'),
                        type: 'ah',
                        key: 'asian',

                    },
                    {
                        title: this.$t('over_under'),
                        type: 'ou',
                        key: 'totals',

                    },
                ],
                actions: [],
                filters: [
                    {
                        "title": this.$t('start_date_range'),
                        "type": "range-picker",
                        "key": "start-time-range",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"]
                    },
                    {
                        "title": this.$t('wdw'),
                        "type": "odds-range-filter",
                        "key": "wdw",
                        "firstTitle": this.$t('home'),
                        "secondTitle": this.$t('draw'),
                        "thirdTitle": this.$t('away'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('asian_handicap'),
                        "type": "odds-range-filter",
                        "key": "ah",
                        "firstTitle": this.$t('line'),
                        "secondTitle": this.$t('home'),
                        "thirdTitle": this.$t('away'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('over_under'),
                        "type": "odds-range-filter",
                        "key": "total",
                        "firstTitle": this.$t('line'),
                        "secondTitle": this.$t('over'),
                        "thirdTitle": this.$t('under'),
                        "stakeTitle": this.$t('stake'),
                        "sign": ""
                    },
                    {
                        "title": this.$t('sort_by'),
                        "type": "checkbox",
                        "key": "sort_by",
                        "option": [
                            {id: 'id', value: 'ID'},
                            {id: 'date', value: 'Start time'},
                            {id: 'wdw_1', value: 'WDW Home'},
                            {id: 'wdw_2', value: 'WDW Draw'},
                            {id: 'wdw_3', value: 'WDW Away'},
                            {id: 'wdw_s', value: 'WDW Stake'},
                            {id: 'ah_1', value: 'AH Line'},
                            {id: 'ah_2', value: 'AH Home'},
                            {id: 'ah_3', value: 'AH Away'},
                            {id: 'ah_s', value: 'AH Stake'},
                            {id: 'ou_1', value: 'OU Line'},
                            {id: 'ou_2', value: 'OU Over'},
                            {id: 'ou_3', value: 'OU Under'},
                            {id: 'ou_s', value: 'OU Stake'},
                            {id: 'odds_added', value: 'Odds Added Time'},
                            {id: 'wdw_added', value: 'WDW Added Time'},
                            {id: 'ah_added', value: 'AH Added Time'},
                            {id: 'ou_added', value: 'OU Added Time'},
                            {id: 'odds_changed', value: 'Odds Changed Time'},
                            {id: 'wdw_changed', value: 'WDW Changed Time'},
                            {id: 'ah_changed', value: 'AH Changed Time'},
                            {id: 'ou_changed', value: 'OU Changed Time'},
                            {id: 'stake_changed', value: 'Stake Changed'},
                            {id: 'wdw_stake_changed', value: 'WDW Stake Changed'},
                            {id: 'ah_stake_changed', value: 'AH Stake Changed'},
                            {id: 'ou_stake_changed', value: 'OU Stake Changed'},
                        ],
                    },
                    {
                        "title": this.$t('order_asc_desc'),
                        "type": "checkbox",
                        "key": "order",
                        "option": [
                            {id: 'asc', value: 'ASC'},
                            {id: 'desc', value: 'DESC'},
                        ],
                    },
                ],
                showFilter: true,
                showSearch: false,
                showCount: true,
                //showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 50,
                showAction: false,
                actionType: "default",
                autoRefresh: true,
                paginationOptions: [25, 50, 100, 200, 500],
                orderBy: 'desc',
            },
        }
    },
    created() {
        this.options.url = actions.BET_DATATABLE_DATA + '/league/' + this.league_id;
    },
    methods: {
        searchAndSelectFilterOptions() {
            /*this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

                name.option = response.data.map(name => {
                    return {
                        id: name.name,
                        value: name.name
                    }
                });
            });*/
        }
    },
}
</script>
